import { PartialTheme } from "@fluentui/react";

export const  appTheme: PartialTheme = {
  palette: {
    themePrimary: '#7f35b2',
    themeLighterAlt: '#fbf7fe',
    themeLighter: '#f9f2fe',
    themeLight: '#ead2fb',
    themeTertiary: '#b07bd6',
    themeSecondary: '#8e4bbd',
    themeDarkAlt: '#611e90',
    themeDark: '#521380',
    themeDarker: '#41056d',
    neutralLighterAlt: '#f8f8f9',
    neutralLighter: '#f2f3f4',
    neutralLight: '#ecedee',
    neutralQuaternaryAlt: '#d9dbdc',
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#bebfc1',
    neutralTertiary: '#b6b7b9',
    neutralSecondary: '#9e9fa2',
    neutralSecondaryAlt: '#9e9fa2',
    neutralPrimaryAlt: '#828487',
    neutralPrimary: '#2a2a2b',
    neutralDark: '#5c5d5f',
    black: '#363739',
    white: '#ffffff'
  }
};
